var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "zdlugpoqaa",
    d: "M0 0.862L9.683 0.862 9.683 5.601 0 5.601z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.697)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "iyct4wkkjb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zdlugpoqaa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#003DB3",
    d: "M7.28.862l-.443 1.593-5.21-.149C.74 2.268.039 2.972.002 3.825c-.037.851.665 1.592 1.515 1.629l5.21.147h.11c1.22 0 2.33-.703 2.847-1.776-.814-1-1.959-2.445-2.366-2.963H7.28z",
    mask: "url(#iyct4wkkjb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B0F0FF",
    d: "M21.58 10.116c-.295-.667-1.072-1-1.737-.704l-2.586 1.112c-2.291-3.63-2.66-3.704-3.215-3.814L11.9 6.302c-.37-.074-.702-.148-4.213.963-.923.296-1.662.888-2.106 1.74l-1.44 2.703c-.333.63-.111 1.445.554 1.778.184.111.407.148.628.148.48 0 .924-.259 1.146-.703l1.44-2.703c.111-.223.333-.408.555-.483.258-.073.48-.147.665-.22-.259.999-.591 2.369-.776 3.072-.296 1.185-.74 2.296-.037 3.222.628.851 3.214 4.073 3.214 4.073.666.815 1.146 1.777 1.478 2.777l1.441 4.518c.222.666.85 1.11 1.516 1.11.147 0 .332-.037.48-.074.813-.259 1.293-1.148 1.034-2l-1.44-4.517c-.444-1.37-1.11-2.628-2.033-3.777l-1.44-1.814 1.846-5.11c.186.296.407.63.628 1 .666 1.036 1.959 1.444 3.105.962l2.66-1.147c.776-.26 1.07-1.037.776-1.704M11.035 2.242c.378-1.57 1.953-2.538 3.52-2.16 1.568.377 2.534 1.957 2.157 3.527-.377 1.572-1.953 2.538-3.52 2.161-1.568-.378-2.534-1.956-2.157-3.528"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRun);
export default __webpack_public_path__ + "static/media/run.2b754731f02d868106519b817d2e42bc.svg";
export { ForwardRef as ReactComponent };